"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RATIO_AAA = exports.RATIO_AA = exports.niveau = exports.luminance = exports.estCouleur = exports.contraste = exports.COUPLES = exports.habillage = exports.HABILLAGES = exports.CIBLES_CONSOLE = exports.CIBLES = exports.SURFACES = void 0;
/**
 * Jetons partagés par les trois surfaces — F-SOC-14.
 *
 * Une seule rampe de marque, trois habillages. Ce qui change d'une surface à
 * l'autre n'est pas le système mais sa densité et son fond, et chacun se
 * justifie par une condition d'usage — pas par un goût.
 */
var surfaces_1 = require("./surfaces");
Object.defineProperty(exports, "SURFACES", { enumerable: true, get: function () { return surfaces_1.SURFACES; } });
var jetons_1 = require("./jetons");
Object.defineProperty(exports, "CIBLES", { enumerable: true, get: function () { return jetons_1.CIBLES; } });
Object.defineProperty(exports, "CIBLES_CONSOLE", { enumerable: true, get: function () { return jetons_1.CIBLES_CONSOLE; } });
Object.defineProperty(exports, "HABILLAGES", { enumerable: true, get: function () { return jetons_1.HABILLAGES; } });
Object.defineProperty(exports, "habillage", { enumerable: true, get: function () { return jetons_1.habillage; } });
var couples_1 = require("./couples");
Object.defineProperty(exports, "COUPLES", { enumerable: true, get: function () { return couples_1.COUPLES; } });
var contraste_1 = require("./contraste");
Object.defineProperty(exports, "contraste", { enumerable: true, get: function () { return contraste_1.contraste; } });
Object.defineProperty(exports, "estCouleur", { enumerable: true, get: function () { return contraste_1.estCouleur; } });
Object.defineProperty(exports, "luminance", { enumerable: true, get: function () { return contraste_1.luminance; } });
Object.defineProperty(exports, "niveau", { enumerable: true, get: function () { return contraste_1.niveau; } });
Object.defineProperty(exports, "RATIO_AA", { enumerable: true, get: function () { return contraste_1.RATIO_AA; } });
Object.defineProperty(exports, "RATIO_AAA", { enumerable: true, get: function () { return contraste_1.RATIO_AAA; } });
//# sourceMappingURL=index.js.map